import DateRangePicker from "components/DateRangePicker";
import {
  PickerRange,
  toIsoPeriod,
  toPickerRange,
} from "@/utils/date-range";
import { DateRange } from "../types";

interface DateRangeInputsProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

export function DateRangeInputs({
  value,
  onChange,
}: DateRangeInputsProps): JSX.Element {
  return (
    <DateRangePicker
      date={toPickerRange(value)}
      onDateChange={(range?: PickerRange) => onChange(toIsoPeriod(range))}
      allowUnlimited
      placeholder="Selecione um período"
      className="h-10"
    />
  );
}
